import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { NbToastrService, NbComponentStatus } from '@nebular/theme';
import * as Sentry from '@sentry/angular';

const TOAST_HEADER_NAME = 'X-WR-Toast';

interface ToastInfo {
  readonly title: string;
  readonly message: string;
  readonly status: NbComponentStatus;
}

@Injectable()
export class ToastInterceptor implements HttpInterceptor {
  private readonly toastrService = inject(NbToastrService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse && event.headers.has(TOAST_HEADER_NAME)) {
          try {
            let toastHeader = event.headers.get(TOAST_HEADER_NAME)!;
            toastHeader = decodeURIComponent(toastHeader);

            const toast: ToastInfo = JSON.parse(toastHeader);

            this.showToast(toast);
          } catch (e) {
            Sentry.captureException(e);
          }
        }
      })
    );
  }

  private showToast(toast: ToastInfo) {
    this.toastrService.show(
      toast.message,
      toast.title,
      {
        status: toast.status.toLowerCase() as NbComponentStatus,
      }
    );
  }
}
